// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"81493be5","380":"03575968","453":"79ec2a8e","644":"2ed1ed2c","687":"3dddc38a","711":"f5880201"}[chunkId] + ".chunk.js";
};